import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function AgingLoanReport() {
  return <ReportForm reportAPI={ ReportAPI.AGING_LOAN } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/AgingLoanReport.js